import React, { useEffect, useState } from "react";
import { useCounter } from "../../hooks/useCounter";
import { useTranslation } from "react-i18next";
import { useAxios } from "../../hooks/useAxios";
import { useAxios3 } from "../../hooks/useAxios";

const Busqueda = ({ cadena, datee, onRetorno = 0 }) => {

    const [t, i18n] = useTranslation("ideas_libertad");
    const [t2] = useTranslation("biblioteca");

    const { counter, increment, defaultValue } = useCounter(0);

    const inputVal = cadena;

    const [toppage, setToppage] = useState(0);

    const [ficha] = useState(12);

    const [url2, setUrl2] = useState("");

    const [url, setUrl] = useState("");

    const [date, setDate] = useState(null);

    const { data, isLoading } = useAxios(url);

    const [blogs, setBlogs] = useState([]);

    const { data2 } = useAxios3(url2);

    const [blogs2, setBlogs2] = useState([]);

    const formatDate = (date) => {

        const options = {
            day: "numeric",
            month: "long",
            year: "numeric"
        };

        return new Date(date).toLocaleDateString(
            i18n.language,
            options
        );
    };



    useEffect(() => {

        if (data) {

            if (counter === 0) {

                setBlogs(data);

            } else {

                setBlogs(prev => [...prev, ...data]);
            }
        }

    }, [data]);

    useEffect(() => {

        if (data2) {

            setBlogs2(data2);

            console.log("Lo que guarda la variable: " + data2.length)
            onRetorno(data2.length);

            const totalPages = Math.ceil(data2.length / 12);

            setToppage(
                totalPages > 0
                    ? totalPages - 1
                    : 0
            );
        }

    }, [data2]);

    useEffect(() => {

        if (date === null) {

            if (inputVal.length >= 1) {

                setUrl(
                    `/blogs/search/by-content?offset=${counter * ficha
                    }&next=${ficha}&lang=${i18n.language}&words=${inputVal}`
                );

                setUrl2(
                    `/blogs/search/by-content?offset=0&next=1200&lang=${i18n.language}&words=${inputVal}`
                );
            }

        } else {

            if (inputVal.length >= 1) {

                setUrl(
                    `/blogs/search/by-content?offset=${counter * ficha
                    }&next=${ficha}&lang=${i18n.language
                    }&words=${inputVal}&sort=${date}`
                );

                setUrl2(
                    `/blogs/search/by-content?offset=0&next=1200&lang=${i18n.language}&words=${inputVal}&sort=${date}`
                );
            }
        }

    }, [counter, i18n.language, inputVal, date]);

    useEffect(() => {

        setUrl(
            `/blogs/search/by-content?offset=0&next=${ficha}&lang=${i18n.language}&words=${inputVal}`
        );

        setUrl2(
            `/blogs/search/by-content?offset=0&next=1200&lang=${i18n.language}&words=${inputVal}`
        );

        setBlogs([]);
        defaultValue(0);

    }, [inputVal]);

    const numero = (txtresumen) => {

        if (
            typeof txtresumen === "string" &&
            txtresumen.trim() !== ""
        ) {

            const partes = txtresumen.split("||");

            if (
                partes.length > 1 &&
                partes[1].trim() !== ""
            ) {
                return partes[1].trim();
            }
        }

        return Math.floor(Math.random() * 5) + 1;
    };

    const resumensplit = (txtresumen) => {

        if (
            typeof txtresumen === "string" &&
            txtresumen.trim() !== ""
        ) {

            const partes = txtresumen.split("||");

            if (
                partes.length > 1 &&
                partes[0].trim() !== ""
            ) {
                return partes[0].trim();
            }
        }

        return txtresumen;
    };

    const nextButton = () => {

        if (counter < toppage) {

            increment();
        }
    };

    return (
        <>

            {blogs.length > 0 ? (
                <>


                    <div
                        id="id-resultados-content"
                        className="blogs-cont-min"
                    >
                        <h4 className="title-busq-in">{t("header.busqueda2")}</h4>

                        {/* DESKTOP */}
                        <div className="_nghost-ng-c732107720">

                            <section
                                aria-label="Resultados relacionados por contenido"
                                className="blog-image-cards-row"
                            >

                                <div className="blog-image-cards-row__inner">

                                    {blogs.map((item, i) => (

                                        <article
                                            key={i}
                                            className="blog-image-cards-row__card"
                                            tabIndex="0"
                                        >

                                            <a href={'/blog/' + item.tag}>

                                                <img
                                                    loading="lazy"
                                                    src={item.urlImagen}
                                                    alt={item.titulo}
                                                />

                                                <div className="blog-image-cards-row__meta">

                                                    <p className="blog-image-cards-row__tag">
                                                        <a className="text-a-link-category" href={"/" + i18n.language + "/Mi-blog?categoria=" + item.categorias[0].tagCategory.toLowerCase()}>
                                                            {item.categorias?.[0]?.nombre?.toUpperCase()}
                                                        </a>
                                                    </p>

                                                    <p className="blog-image-cards-row__meta-text">
                                                        {formatDate(item.fecha)} · {numero(item.resumen)} MIN
                                                    </p>

                                                </div>

                                                <h3>
                                                    {item.titulo}
                                                </h3>

                                                <p className="blog-image-cards-row__excerpt">

                                                    {resumensplit(item.resumen)?.substring(0, 180)}...

                                                </p>

                                            </a>

                                        </article>
                                    ))}

                                </div>

                            </section>

                        </div>

                        {/* MOBILE */}
                        <div
                            arialabel="Resultados móviles"
                            className="_nghost-ng-c2676785337"
                        >

                            <section
                                className="blog-mobile-stories"
                                aria-label="Resultados móviles"
                            >

                                <div className="blog-mobile-stories__inner">

                                    {blogs.map((item, i) => (

                                        <article
                                            key={i}
                                            className="blog-mobile-stories__story"
                                            tabIndex="0"
                                        >

                                            <a href={'/blog/' + item.tag}>

                                                <img
                                                    loading="lazy"
                                                    src={item.urlImagen}
                                                    alt={item.titulo}
                                                />

                                                <p className="blog-mobile-stories__tag">
                                                    <a className="text-a-link-category" href={"/" + i18n.language + "/Mi-blog?categoria=" + item.categorias[0].tagCategory.toLowerCase()}>
                                                        {item.categorias?.[0]?.nombre?.toUpperCase()}
                                                    </a>
                                                </p>

                                                <p className="blog-mobile-stories__meta">
                                                    {formatDate(item.fecha)} · {numero(item.resumen)} MIN
                                                </p>

                                                <h3>
                                                    {item.titulo}
                                                </h3>

                                                <p className="blog-mobile-stories__excerpt">

                                                    {resumensplit(item.resumen)?.substring(0, 110)}...

                                                </p>

                                            </a>

                                        </article>
                                    ))}

                                </div>

                            </section>

                        </div>

                        {/* LOAD MORE */}
                        {blogs.length < data2?.length && (

                            <div className="blog-page__load-more-wrap">

                                <button
                                    type="button"
                                    className="blog-page__load-more-button"
                                    onClick={nextButton}
                                    disabled={isLoading}
                                >

                                    {isLoading
                                        ? t("header.cargando")
                                        : t("header.exploramas")
                                    }

                                </button>

                            </div>
                        )}

                    </div>
                </>
            ) : (
                <>{/*
                        <h4 className="no-encontrado">
                            No se encontraron blogs con contenido relacionado
                        </h4>*/}
                </>


            )}
        </>

    );
};

export default Busqueda;